import React from "react";
import { SEGMENT_BZA, SEGMENT_CMC } from "../../constants";
import { HeroPackage } from "./HeroPackage";
import clsx from "clsx";
import { HeroRequest } from "./HeroRequest";

interface HeroProps {
	title: string;
	subtitle: string;
	packages: {
		label?: typeof SEGMENT_CMC | typeof SEGMENT_BZA | "Most Popular";
		title?: string;
		subtitle?: string;
		description?: string;
		features?: string[];
		subscribeLinkUrl?: string;
	}[];
}

export function Hero({ title, subtitle, packages }: HeroProps) {
	const singlePackage = packages.length === 1;

	const subscriptionOptions = packages.map((item, index) => {
		const {
			label,
			title,
			subtitle,
			description,
			features,
			subscribeLinkUrl,
		} = item;

		return (
			<HeroPackage
				key={index}
				label={label}
				title={title}
				description={description}
				subtitle={subtitle}
				features={features}
				subscribeLinkUrl={subscribeLinkUrl}
			/>
		);
	});

	return (
		<section
			className={clsx("section--hero", {
				"section--hero-single-package": singlePackage,
			})}
		>
			<div className="hero__content">
				<div className="hero__banner grid">
					<div className="hero__title grid__col-12 grid__col-sm-5 align-start">
						<h1>{title}</h1>
						<p className="hero__lead">{subtitle}</p>
					</div>
					<div
						className={clsx("hero__packages", {
							"grid__col-12 grid__col-sm-7": singlePackage,
						})}
					>
						{subscriptionOptions}
					</div>
					{!singlePackage && (
						<div className="hero__packages-disclaimer">
							<span>
								All subscriptions are billed monthly and can be
								cancelled monthly, no long-term commitment.
							</span>
						</div>
					)}
					<HeroRequest singlePackage={singlePackage} />
				</div>
			</div>
		</section>
	);
}
